import { actionTypes, DEFAULT_PAGE_NUMBER } from './constants';
import {
    addNewPageToPowertrainList,
    updatePowertrainById
} from './helpers';
import { apiCallStatus } from 'helpers/constants';


const initialState = {
    powertrains: {
        data: [],
        loadingStatus: null,
        pageNumber: DEFAULT_PAGE_NUMBER,
        hasMore: true
    },
    selectedPowertrain: null,
    searchboxFilter: null,
    hierarchyData: {
        data: {},
        loadingStatus: null,
    },
    selectedHierarchyNodes: [],
    hierarchyExpandedNodes: [],
    isEditHierarchy: false,
    hierarchyRequestData: [],
    hierarchySelectedAssets: [],
    updateHierarchyLoadingStatus: null,

    // Error Modal
    hierarchyErrorModalVisible: false,
    isSaveFailed: false,
    isPartialPowertrainFailure: false,

    // Convert to Location result
    conversionResult: null,
};

export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.CLEAR_STORE: {
            return initialState;
        }
        case actionTypes.GET_POWERTRAINS: {
            return {
                ...state,
                powertrains: addNewPageToPowertrainList(state.powertrains, action)
            };
        }
        case actionTypes.SET_SELECTED_POWERTRAIN: {
            return {
                ...state,
                selectedPowertrain: action.powertrain
            };
        }
        case actionTypes.DELETE_POWERTRAIN: {
            return {
                ...state,
                powertrains: {
                    ...state.powertrains,
                    loadingStatus: action.loadingStatus
                },
                selectedPowertrain: null
            };
        }
        case actionTypes.ADD_POWERTRAIN_SUCCESS: {
            return {
                ...state,
                powertrains: {
                    ...state.powertrains,
                    loadingStatus: action.loadingStatus
                }
            };
        }
        case actionTypes.EDIT_POWERTRAIN_SUCCESS: {
            // Transform action to match updatePowertrainById expectations
            const transformedAction = {
                loadingStatus: apiCallStatus.SUCCESS,
                data: action.payload
            };
            const updatedPowertrains = updatePowertrainById(state.powertrains, transformedAction);
            // If the edited powertrain is currently selected, update it with the new data
            const updatedSelectedPowertrain = state.selectedPowertrain?.powertrainId === action.payload?.powertrainId
                ? action.payload.powertrain
                : state.selectedPowertrain;

            return {
                ...state,
                powertrains: updatedPowertrains,
                selectedPowertrain: updatedSelectedPowertrain
            };
        }
        case actionTypes.SET_SEARCHBOX_FILTER: {
            return {
                ...state,
                searchboxFilter: action.searchboxFilter,
                selectedPowertrain: null
            };
        }
        case actionTypes.GET_HIERARCHY_DATA_SETTINGS: {
            return {
                ...state,
                hierarchyData: {
                    ...action
                }
            };
        }
        case actionTypes.UPDATE_HIERARCHY_DATA_SETTINGS: {
            return {
                ...state,
                updateHierarchyLoadingStatus: action.loadingStatus
            };
        }
        case actionTypes.SET_SELECTED_HIERARCHY_NODES: {
            return {
                ...state,
                selectedHierarchyNodes: action.selectedNodes
            };
        }
        case actionTypes.SET_HIERARCHY_EXPANDED_NODES: {
            return {
                ...state,
                hierarchyExpandedNodes: action.expandedIds
            };
        }
        case actionTypes.SET_IS_EDIT_HIERARCHY: {
            return {
                ...state,
                isEditHierarchy: action.isEditHierarchy
            };
        }
        case actionTypes.SET_HIERARCHY_REQUEST_DATA: {
            return {
                ...state,
                hierarchyRequestData: action.requestData
            };
        }
        case actionTypes.SET_HIERARCHY_SELECTED_ASSETS: {
            return {
                ...state,
                hierarchySelectedAssets: action.selectedAssets
            };
        }
        case actionTypes.SET_HIERARCHY_ERROR_MODAL: {
            return {
                ...state,
                hierarchyErrorModalVisible: action.isVisible
            };
        }
        case actionTypes.SET_SAVE_FAILED: {
            return {
                ...state,
                isSaveFailed: action.isSaveFailed
            };
        }
        case actionTypes.SET_PARTIAL_POWERTRAIN_FAILURE: {
            return {
                ...state,
                isPartialPowertrainFailure: action.isPartialPowertrainFailure
            };
        }
        case actionTypes.SET_CONVERSION_RESULT: {
            return {
                ...state,
                conversionResult: action.conversionResult
            };
        }
        case actionTypes.CLEAR_CONVERSION_RESULT: {
            return {
                ...state,
                conversionResult: null
            };
        }
        default:
            return state;
    }
};
